import React from 'react';

import {observer} from "mobx-react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsWidgetGroupedRowsViewModel} from "../../models/standings-widget.grouped-rows-view-model";
import {STANDINGS_WIDGET} from "../../standings-widget.consts";
import {StandingsWidgetController} from "../../standings-widget.controller";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";

export class StandingsWidgetGroupHeaderProps extends BaseProps {
  group: StandingsWidgetGroupedRowsViewModel;
  controller: StandingsWidgetController;
}

export const StandingsWidgetGroupHeader = observer(({controller, group}: StandingsWidgetGroupHeaderProps) => {
  const {state} = controller;

  const onToggleGroup = () => controller.action(STANDINGS_WIDGET.ACTION_TYPES.toggleGroup, {group});

  const titleProps = {
    className: classNames(styles.group_header),
    onClick: () => state.shouldRenderGroupArrows && onToggleGroup(),
  }

  return (
    <div {...titleProps}>
      {group.name}
    </div>
  )
});
